import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { HttpMethod_POST_getInstance3c6ouf174z7cx as HttpMethod_POST_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { serializer1cdzkc3mnhoc4 as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from './GenericDialog.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  Set2awzlbbrsme5i as Set,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { get_appThemejy2o9bdilpry as get_appTheme } from '../theming/appTheme.mjs';
import {
  title1nssp3ryhwuqj as title,
  smallBody2trfy14zwtona as smallBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../theming/Titles.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  Companion_getInstance2v0f9t0g75gcs as Companion_getInstance_0,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
import { paymentSetupaftd7izh36vp as paymentSetup } from '../../actuals/paymentActuals.js.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { lazygopf2ohairjp as lazy } from '../../utils/utils.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../selectedContractor.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PaymentErrorClass;
function PaymentError() {
  if (PaymentErrorClass === VOID) {
    class $ {
      constructor(type, code, message) {
        this.nij_1 = type;
        this.oij_1 = code;
        this.pij_1 = message;
      }
      toString() {
        return 'PaymentError(type=' + this.nij_1 + ', code=' + this.oij_1 + ', message=' + this.pij_1 + ')';
      }
      hashCode() {
        var result = this.nij_1 == null ? 0 : getStringHashCode(this.nij_1);
        result = imul(result, 31) + (this.oij_1 == null ? 0 : getStringHashCode(this.oij_1)) | 0;
        result = imul(result, 31) + (this.pij_1 == null ? 0 : getStringHashCode(this.pij_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PaymentError()))
          return false;
        if (!(this.nij_1 == other.nij_1))
          return false;
        if (!(this.oij_1 == other.oij_1))
          return false;
        if (!(this.pij_1 == other.pij_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PaymentError');
    PaymentErrorClass = $;
  }
  return PaymentErrorClass;
}
var PaymentResultClass;
function PaymentResult() {
  if (PaymentResultClass === VOID) {
    class $ {
      constructor(method, error) {
        this.qij_1 = method;
        this.rij_1 = error;
      }
      toString() {
        return 'PaymentResult(method=' + this.qij_1 + ', error=' + toString(this.rij_1) + ')';
      }
      hashCode() {
        var result = this.qij_1 == null ? 0 : getStringHashCode(this.qij_1);
        result = imul(result, 31) + (this.rij_1 == null ? 0 : this.rij_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PaymentResult()))
          return false;
        if (!(this.qij_1 == other.qij_1))
          return false;
        if (!equals(this.rij_1, other.rij_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PaymentResult');
    PaymentResultClass = $;
  }
  return PaymentResultClass;
}
var PaymentConfigClass;
function PaymentConfig() {
  if (PaymentConfigClass === VOID) {
    class $ {
      constructor(token, publicKey, user) {
        this.sij_1 = token;
        this.tij_1 = publicKey;
        this.uij_1 = user;
      }
      cf() {
        return this.sij_1;
      }
      df() {
        return this.tij_1;
      }
      ww() {
        return this.uij_1;
      }
      toString() {
        return 'PaymentConfig(token=' + this.sij_1 + ', publicKey=' + this.tij_1 + ', user=' + this.uij_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.sij_1);
        result = imul(result, 31) + getStringHashCode(this.tij_1) | 0;
        result = imul(result, 31) + this.uij_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PaymentConfig()))
          return false;
        if (!(this.sij_1 === other.sij_1))
          return false;
        if (!(this.tij_1 === other.tij_1))
          return false;
        if (!this.uij_1.equals(other.uij_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PaymentConfig');
    PaymentConfigClass = $;
  }
  return PaymentConfigClass;
}
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.tfw().bfh_1.ifs($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = session.tfw().bfh_1.jfs($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = await_0(session.pfw_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return new (PaymentConfig())(tmp_0, tmp_1, tmp_2);
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().gff_1.fei('auth/user/payments/create-mock-bank', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  get_dialogStack().ngd();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.vij_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  if (!(result.qij_1 == null)) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp_0 = await_0(this_0, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = tmp_0.tfw().bfh_1.lfs(result.qij_1, $this.wij_1.zij_1.f2(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var result_0 = tmp_1;
    var tmp_2 = $this.wij_1.yij_1($this.xij_1, result_0, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    get_dialogStack().ngd();
  } else {
    var tmp_3 = get_dialogStack();
    var tmp0_safe_receiver = result.rij_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pij_1;
    tmp_3.ebw(GenericDialog().zgy(tmp1_elvis_lhs == null ? 'An unknown error occurred.' : tmp1_elvis_lhs));
  }
  return Unit_instance;
}
var SetupCustomerMethodDialog$render$slambdaClass;
function SetupCustomerMethodDialog$render$slambda() {
  if (SetupCustomerMethodDialog$render$slambdaClass === VOID) {
    class $ {
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SetupCustomerMethodDialog$render$slambdaClass = $;
  }
  return SetupCustomerMethodDialog$render$slambdaClass;
}
function SetupCustomerMethodDialog$render$slambda_0() {
  var i = new (SetupCustomerMethodDialog$render$slambda())();
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var SetupCustomerMethodDialog$render$slambdaClass_0;
function SetupCustomerMethodDialog$render$slambda_1() {
  if (SetupCustomerMethodDialog$render$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SetupCustomerMethodDialog$render$slambdaClass_0 = $;
  }
  return SetupCustomerMethodDialog$render$slambdaClass_0;
}
function SetupCustomerMethodDialog$render$slambda_2() {
  var i = new (SetupCustomerMethodDialog$render$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var SetupCustomerMethodDialog$render$lambda$slambdaClass;
function SetupCustomerMethodDialog$render$lambda$slambda() {
  if (SetupCustomerMethodDialog$render$lambda$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SetupCustomerMethodDialog$render$lambda$slambdaClass = $;
  }
  return SetupCustomerMethodDialog$render$lambda$slambdaClass;
}
function SetupCustomerMethodDialog$render$lambda$slambda_0() {
  var i = new (SetupCustomerMethodDialog$render$lambda$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var SetupCustomerMethodDialog$render$lambda$slambdaClass_0;
function SetupCustomerMethodDialog$render$lambda$slambda_1() {
  if (SetupCustomerMethodDialog$render$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($confirmSetup, this$0, $$this$button) {
        this.vij_1 = $confirmSetup;
        this.wij_1 = this$0;
        this.xij_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SetupCustomerMethodDialog$render$lambda$slambdaClass_0 = $;
  }
  return SetupCustomerMethodDialog$render$lambda$slambdaClass_0;
}
function SetupCustomerMethodDialog$render$lambda$slambda_2($confirmSetup, this$0, $$this$button) {
  var i = new (SetupCustomerMethodDialog$render$lambda$slambda_1())($confirmSetup, this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var SetupCustomerMethodDialog$render$lambda$slambdaClass_1;
function SetupCustomerMethodDialog$render$lambda$slambda_3() {
  if (SetupCustomerMethodDialog$render$lambda$slambdaClass_1 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SetupCustomerMethodDialog$render$lambda$slambdaClass_1 = $;
  }
  return SetupCustomerMethodDialog$render$lambda$slambdaClass_1;
}
function SetupCustomerMethodDialog$render$lambda$slambda_4() {
  var i = new (SetupCustomerMethodDialog$render$lambda$slambda_3())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var SetupCustomerMethodDialogClass;
function SetupCustomerMethodDialog() {
  if (SetupCustomerMethodDialogClass === VOID) {
    class $ {
      constructor(onComplete) {
        this.yij_1 = onComplete;
        this.zij_1 = Signal().fak('');
        this.aik_1 = Signal().fak(false);
      }
      ud6(_this__u8e3s4) {
        var keys = rememberSuspending(VOID, VOID, VOID, SetupCustomerMethodDialog$render$slambda_0());
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(SetupCustomerMethodDialog$render$slambda_2());
        var tmp = view.ibb(view.hbb(DialogSemantic_getInstance()), get_centered(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        view_0.zb8(get_AppDimensions().wg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        Companion_getInstance();
        // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
        var theme = get_appTheme();
        var tmp$ret$0 = new (Set())(theme);
        view_1.jba(tmp$ret$0);
        lazy(view_1, keys, ($this$lazy, _destruct__k2r9zo) => {
          var setup = _destruct__k2r9zo.cf();
          var public_0 = _destruct__k2r9zo.df();
          var user = _destruct__k2r9zo.ww();
          if (setup === 'Mock Payment' || public_0 === 'Mock Payment') {
            var tmp = sizeConstraints($this$lazy, VOID, VOID, VOID, VOID, VOID, get_rem(30));
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (TextView())($this$lazy.pc());
            var tmp0_elvis_lhs = $this$lazy.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$lazy : tmp0_elvis_lhs;
            $this$lazy.ebb(p, view);
            view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
            view.bbs(Align_Center_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
            var value = 'We are currently using mock payments. We will automatically create a mock payment object. No money will be transferred, and no banking information gathered.';
            var tmp_0 = view.tb5_1;
            var tmp_1;
            // Inline function 'kotlin.text.isEmpty' call
            if (charSequenceLength(value) === 0) {
              tmp_1 = '\xA0';
            } else {
              tmp_1 = value;
            }
            tmp_0.fbu(tmp_1);
            $this$lazy.fbb(p, view);
            $this$lazy.jbb(tmp, view);
            // Inline function 'com.lightningkite.kiteui.views.direct.space' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (Space())($this$lazy.pc());
            var tmp0_elvis_lhs_0 = $this$lazy.cbb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? $this$lazy : tmp0_elvis_lhs_0;
            $this$lazy.ebb(p_0, view_0);
            $this$lazy.fbb(p_0, view_0);
            var tmp_2 = get_tertiaryButton($this$lazy);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_1 = new (Button())($this$lazy.pc());
            var tmp0_elvis_lhs_1 = $this$lazy.cbb_1;
            var p_1 = tmp0_elvis_lhs_1 == null ? $this$lazy : tmp0_elvis_lhs_1;
            $this$lazy.ebb(p_1, view_1);
            specCenteredText(view_1, 'Ok');
            onClick(view_1, VOID, VOID, SetupCustomerMethodDialog$render$lambda$slambda_0());
            $this$lazy.fbb(p_1, view_1);
            $this$lazy.jbb(tmp_2, view_1);
          } else {
            title($this$lazy, 'Connect Account');
            label2($this$lazy, 'Account Nickname', VOID, ($this$label2) => {
              // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
              var tmp = $this$label2.hbb(FieldSemantic_getInstance());
              // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (TextInput())($this$label2.pc());
              var tmp0_elvis_lhs = $this$label2.cbb_1;
              var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
              $this$label2.ebb(p, view);
              // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
              var value = 'Account Nickname';
              // Inline function 'com.lightningkite.kiteui.views.placeholder' call
              view.tb5_1.zb3_1.ib7_1.placeholder = value;
              view.abs(Companion_getInstance_0().qd5_1);
              view.xah(view.gcn_1, this.zij_1);
              $this$label2.fbb(p, view);
              return $this$label2.jbb(tmp, view);
            });
            smallBody($this$lazy, 'Powered by Stripe');
            var confirmSetup = paymentSetup($this$lazy, setup, public_0, user, (isComplete) => {
              this.aik_1.mam(isComplete);
              return Unit_instance;
            });
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_2 = new (RowOrCol())($this$lazy.pc());
            var tmp0_elvis_lhs_2 = $this$lazy.cbb_1;
            var p_2 = tmp0_elvis_lhs_2 == null ? $this$lazy : tmp0_elvis_lhs_2;
            $this$lazy.ebb(p_2, view_2);
            view_2.xbm(false);
            view_2.zb8(get_AppDimensions().ig2_1);
            var tmp_3 = get_primaryButton(view_2);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_3 = new (Button())(view_2.pc());
            var tmp0_elvis_lhs_3 = view_2.cbb_1;
            var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
            view_2.ebb(p_3, view_3);
            var tmp_4 = KMutableProperty0();
            var tmp_5 = Button$_get_enabled_$ref_61t7nx(view_3);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz(view_3));
            reactiveScope(view_3, ($this$reactiveScope) => {
              var tmp$ret$20 = $this$reactiveScope.baj(this.aik_1);
              this_0.set(tmp$ret$20);
              return Unit_instance;
            });
            specCenteredText(view_3, 'Confirm');
            onClick(view_3, VOID, VOID, SetupCustomerMethodDialog$render$lambda$slambda_2(confirmSetup, this, view_3));
            view_2.fbb(p_3, view_3);
            view_2.jbb(tmp_3, view_3);
            var tmp_6 = get_textButton(view_2);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_4 = new (Button())(view_2.pc());
            var tmp0_elvis_lhs_4 = view_2.cbb_1;
            var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
            view_2.ebb(p_4, view_4);
            specCenteredText(view_4, 'Go Back');
            onClick(view_4, VOID, VOID, SetupCustomerMethodDialog$render$lambda$slambda_4());
            view_2.fbb(p_4, view_4);
            view_2.jbb(tmp_6, view_4);
            $this$lazy.fbb(p_2, view_2);
          }
          return Unit_instance;
        });
        view_0.fbb(p_1, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'SetupCustomerMethodDialog', VOID, VOID, [Page()]);
    SetupCustomerMethodDialogClass = $;
  }
  return SetupCustomerMethodDialogClass;
}
function *_generator_invoke__zhh2q8_2($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = $this.bik_1.gik($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = session.tfw().bfh_1.jfs($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = await_0(session.pfw_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return new (PaymentConfig())(tmp_0, tmp_1, tmp_2);
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = $this.hik_1.dik_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  get_dialogStack().ngd();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().gff_1.fei('auth/user/payments/create-mock-bank', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.iik_1.cik_1($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  get_dialogStack().ngd();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.jik_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  if (!(result.qij_1 == null)) {
    var tmp_0 = $this.kik_1.cik_1($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    get_dialogStack().ngd();
  } else {
    var tmp_1 = get_dialogStack();
    var tmp0_safe_receiver = result.rij_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pij_1;
    tmp_1.ebw(GenericDialog().zgy(tmp1_elvis_lhs == null ? 'An unknown error occurred.' : tmp1_elvis_lhs));
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.lik_1.dik_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  get_dialogStack().ngd();
  return Unit_instance;
}
var SetupFinancialConnectionDialog$render$slambdaClass;
function SetupFinancialConnectionDialog$render$slambda() {
  if (SetupFinancialConnectionDialog$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.bik_1 = this$0;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SetupFinancialConnectionDialog$render$slambdaClass = $;
  }
  return SetupFinancialConnectionDialog$render$slambdaClass;
}
function SetupFinancialConnectionDialog$render$slambda_0(this$0) {
  var i = new (SetupFinancialConnectionDialog$render$slambda())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var SetupFinancialConnectionDialog$render$slambdaClass_0;
function SetupFinancialConnectionDialog$render$slambda_1() {
  if (SetupFinancialConnectionDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.hik_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SetupFinancialConnectionDialog$render$slambdaClass_0 = $;
  }
  return SetupFinancialConnectionDialog$render$slambdaClass_0;
}
function SetupFinancialConnectionDialog$render$slambda_2(this$0) {
  var i = new (SetupFinancialConnectionDialog$render$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var SetupFinancialConnectionDialog$render$lambda$slambdaClass;
function SetupFinancialConnectionDialog$render$lambda$slambda() {
  if (SetupFinancialConnectionDialog$render$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.iik_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SetupFinancialConnectionDialog$render$lambda$slambdaClass = $;
  }
  return SetupFinancialConnectionDialog$render$lambda$slambdaClass;
}
function SetupFinancialConnectionDialog$render$lambda$slambda_0(this$0) {
  var i = new (SetupFinancialConnectionDialog$render$lambda$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var SetupFinancialConnectionDialog$render$lambda$slambdaClass_0;
function SetupFinancialConnectionDialog$render$lambda$slambda_1() {
  if (SetupFinancialConnectionDialog$render$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($confirmSetup, this$0) {
        this.jik_1 = $confirmSetup;
        this.kik_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SetupFinancialConnectionDialog$render$lambda$slambdaClass_0 = $;
  }
  return SetupFinancialConnectionDialog$render$lambda$slambdaClass_0;
}
function SetupFinancialConnectionDialog$render$lambda$slambda_2($confirmSetup, this$0) {
  var i = new (SetupFinancialConnectionDialog$render$lambda$slambda_1())($confirmSetup, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var SetupFinancialConnectionDialog$render$lambda$slambdaClass_1;
function SetupFinancialConnectionDialog$render$lambda$slambda_3() {
  if (SetupFinancialConnectionDialog$render$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.lik_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SetupFinancialConnectionDialog$render$lambda$slambdaClass_1 = $;
  }
  return SetupFinancialConnectionDialog$render$lambda$slambdaClass_1;
}
function SetupFinancialConnectionDialog$render$lambda$slambda_4(this$0) {
  var i = new (SetupFinancialConnectionDialog$render$lambda$slambda_3())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var SetupFinancialConnectionDialogClass;
function SetupFinancialConnectionDialog() {
  if (SetupFinancialConnectionDialogClass === VOID) {
    class $ {
      constructor(onComplete, onCancel) {
        this.cik_1 = onComplete;
        this.dik_1 = onCancel;
        this.eik_1 = Signal().fak('');
        this.fik_1 = Signal().fak(false);
      }
      ud6(_this__u8e3s4) {
        var keys = rememberSuspending(VOID, VOID, VOID, SetupFinancialConnectionDialog$render$slambda_0(this));
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(SetupFinancialConnectionDialog$render$slambda_2(this));
        var tmp = view.ibb(view.hbb(DialogSemantic_getInstance()), get_centered(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        view_0.zb8(get_AppDimensions().wg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        Companion_getInstance();
        // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
        var theme = get_appTheme();
        var tmp$ret$0 = new (Set())(theme);
        view_1.jba(tmp$ret$0);
        lazy(view_1, keys, ($this$lazy, _destruct__k2r9zo) => {
          var setup = _destruct__k2r9zo.cf();
          var public_0 = _destruct__k2r9zo.df();
          var user = _destruct__k2r9zo.ww();
          if (setup === 'Mock Payment' || public_0 === 'Mock Payment') {
            var tmp = sizeConstraints($this$lazy, VOID, VOID, VOID, VOID, VOID, get_rem(30));
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (TextView())($this$lazy.pc());
            var tmp0_elvis_lhs = $this$lazy.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$lazy : tmp0_elvis_lhs;
            $this$lazy.ebb(p, view);
            view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
            view.bbs(Align_Center_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
            var value = 'We are currently using mock payments. We will automatically create a mock payment object. No money will be transferred, and no banking information gathered.';
            var tmp_0 = view.tb5_1;
            var tmp_1;
            // Inline function 'kotlin.text.isEmpty' call
            if (charSequenceLength(value) === 0) {
              tmp_1 = '\xA0';
            } else {
              tmp_1 = value;
            }
            tmp_0.fbu(tmp_1);
            $this$lazy.fbb(p, view);
            $this$lazy.jbb(tmp, view);
            // Inline function 'com.lightningkite.kiteui.views.direct.space' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (Space())($this$lazy.pc());
            var tmp0_elvis_lhs_0 = $this$lazy.cbb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? $this$lazy : tmp0_elvis_lhs_0;
            $this$lazy.ebb(p_0, view_0);
            $this$lazy.fbb(p_0, view_0);
            var tmp_2 = get_tertiaryButton($this$lazy);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_1 = new (Button())($this$lazy.pc());
            var tmp0_elvis_lhs_1 = $this$lazy.cbb_1;
            var p_1 = tmp0_elvis_lhs_1 == null ? $this$lazy : tmp0_elvis_lhs_1;
            $this$lazy.ebb(p_1, view_1);
            specCenteredText(view_1, 'Ok');
            onClick(view_1, VOID, VOID, SetupFinancialConnectionDialog$render$lambda$slambda_0(this));
            $this$lazy.fbb(p_1, view_1);
            $this$lazy.jbb(tmp_2, view_1);
          } else {
            title($this$lazy, 'Connect Account');
            smallBody($this$lazy, 'Powered by Stripe');
            var confirmSetup = paymentSetup($this$lazy, setup, public_0, user, (isComplete) => {
              this.fik_1.mam(isComplete);
              return Unit_instance;
            });
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_2 = new (RowOrCol())($this$lazy.pc());
            var tmp0_elvis_lhs_2 = $this$lazy.cbb_1;
            var p_2 = tmp0_elvis_lhs_2 == null ? $this$lazy : tmp0_elvis_lhs_2;
            $this$lazy.ebb(p_2, view_2);
            view_2.xbm(false);
            view_2.zb8(get_AppDimensions().ig2_1);
            var tmp_3 = get_primaryButton(view_2);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_3 = new (Button())(view_2.pc());
            var tmp0_elvis_lhs_3 = view_2.cbb_1;
            var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
            view_2.ebb(p_3, view_3);
            var tmp_4 = KMutableProperty0();
            var tmp_5 = Button$_get_enabled_$ref_61t7nx_0(view_3);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz_0(view_3));
            reactiveScope(view_3, ($this$reactiveScope) => {
              var tmp$ret$14 = $this$reactiveScope.baj(this.fik_1);
              this_0.set(tmp$ret$14);
              return Unit_instance;
            });
            specCenteredText(view_3, 'Confirm');
            onClick(view_3, VOID, VOID, SetupFinancialConnectionDialog$render$lambda$slambda_2(confirmSetup, this));
            view_2.fbb(p_3, view_3);
            view_2.jbb(tmp_3, view_3);
            var tmp_6 = get_textButton(view_2);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_4 = new (Button())(view_2.pc());
            var tmp0_elvis_lhs_4 = view_2.cbb_1;
            var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
            view_2.ebb(p_4, view_4);
            specCenteredText(view_4, 'Go Back');
            onClick(view_4, VOID, VOID, SetupFinancialConnectionDialog$render$lambda$slambda_4(this));
            view_2.fbb(p_4, view_4);
            view_2.jbb(tmp_6, view_4);
            $this$lazy.fbb(p_2, view_2);
          }
          return Unit_instance;
        });
        view_0.fbb(p_1, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'SetupFinancialConnectionDialog', VOID, VOID, [Page()], [0]);
    SetupFinancialConnectionDialogClass = $;
  }
  return SetupFinancialConnectionDialogClass;
}
function *_generator_getSetupToken__kjwtc2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().mff_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_notNullContractor();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = tmp_0.lfi(tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
var ContractorFinancialConnectionClass;
function ContractorFinancialConnection() {
  if (ContractorFinancialConnectionClass === VOID) {
    class $ extends SetupFinancialConnectionDialog() {
      gik($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_getSetupToken__kjwtc2.bind(VOID, this), $completion);
      }
    }
    initMetadataForClass($, 'ContractorFinancialConnection', VOID, VOID, VOID, [0]);
    ContractorFinancialConnectionClass = $;
  }
  return ContractorFinancialConnectionClass;
}
//region block: exports
export {
  ContractorFinancialConnection as ContractorFinancialConnection7bkl9pu54014,
  PaymentError as PaymentError3jximuuva0fyd,
  PaymentResult as PaymentResult1ux92yt3kvdva,
  SetupCustomerMethodDialog as SetupCustomerMethodDialog2y75086l50hfg,
};
//endregion

//# sourceMappingURL=SetupCustomerMethodDialog.mjs.map
